import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-produit-crm',
  templateUrl: './produit-crm.component.html',
  styleUrls: ['./produit-crm.component.scss']
})
export class ProduitCrmComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
